// 搜索历史 - 这些是可以搜索出内容的字段
export const SEARCH_HISTORY = ['存款', '八个壹', '代发', '大额', '客户资产', '贷款余额', '贷款金额', '账户信息', '交易流水']

// 数据资产
export const ASSET_DATA = [
  {
    id: '1',
    name: '风险资产分类统计',
    description: '统计全行风险资产五级分类情况，包括正常、关注、次级、可疑、损失各类资产余额及占比',
    department: '风险管理部',
    owner: '李四',
    path: '授信风险板块>五级分类>风险资产分类统计',
    authorized: true,
    viewCount: 89,
    likeCount: 7,
    commentCount: 1,
    roles: ['风险管理角色', '授信审批角色'],
    catalogPath: ['授信风险板块', '五级分类'],
    catalogId: 'risk-classification',
    keywords: ['风险', '分类', '资产', '管理', '五级分类', '贷款余额', '贷款金额'],
    definition: '记录全行风险资产按五级分类标准的统计结果，用于监管报送和内部风险管理',
    caliber: '统计口径：含正常、关注、次级、可疑、损失五级分类；币种：折合人民币；更新频率：T+1',
    hidden: false,
  },
  {
    id: '2',
    name: '零售客户信息',
    description: '零售板块客户基础信息，包含客户身份、联系方式、风险等级等',
    department: '零售金融部',
    owner: '数据管理员',
    path: '零售金融板块>客户管理>零售客户信息',
    authorized: true,
    viewCount: 128,
    likeCount: 15,
    commentCount: 3,
    roles: ['零售业务角色', '数据分析角色'],
    catalogPath: ['零售金融板块', '客户管理'],
    catalogId: 'retail-customer',
    keywords: ['客户', '零售', '信息', '管理', '客户存款', '客户资产', '代发', '代发客群', '存款余额'],
    definition: '记录零售客户的基础身份信息、联系信息、风险评级等核心数据',
    caliber: '统计口径：有效客户（状态=正常）；更新频率：T+1；数据来源：核心系统',
    hidden: false,
  },
  {
    id: '3',
    name: '对公存款日报',
    description: '对公存款每日余额及变动情况统计',
    department: '公司金融部',
    owner: '张三',
    path: '对公金融板块>存款业务>对公存款日报',
    authorized: true,
    viewCount: 256,
    likeCount: 32,
    commentCount: 8,
    roles: ['公司业务角色', '管理报表角色'],
    catalogPath: ['对公金融板块', '存款业务'],
    catalogId: 'retail-deposit',
    keywords: ['存款', '对公', '日报', '业务', '客户存款', '大额', '大额存款', '存款余额'],
    definition: '统计对公客户存款账户的每日余额、当日发生额、累计发生额等指标',
    caliber: '统计口径：时点余额为日终余额；发生额为当日借贷方合计；币种：全币种折合人民币',
    hidden: false,
  },
  {
    id: '4',
    name: '授信业务明细',
    description: '全行授信业务借据级别明细数据',
    department: '风险管理部',
    owner: '李四',
    path: '授信风险板块>授信用信信息>授信业务明细',
    authorized: true,
    viewCount: 178,
    likeCount: 21,
    commentCount: 5,
    roles: ['风险管理角色', '授信审批角色'],
    catalogPath: ['授信风险板块', '授信用信信息'],
    catalogId: 'risk-credit',
    keywords: ['授信', '业务', '风险', '管理', '贷款金额', '贷款余额'],
    definition: '记录每笔授信业务的详细信息，包括客户、金额、期限、担保方式等',
    caliber: '统计口径：含正常、关注、次级、可疑、损失五级分类；币种：原币种',
    hidden: false,
  },
  {
    id: '5',
    name: '金融市场交易流水',
    description: '金融市场业务交易明细流水',
    department: '金融市场部',
    owner: '王五',
    path: '金融市场板块>同业业务>金融市场交易流水',
    authorized: true,
    viewCount: 167,
    likeCount: 21,
    commentCount: 5,
    roles: ['金融市场角色', '资金业务角色'],
    catalogPath: ['金融市场板块', '同业业务'],
    catalogId: 'market-bond',
    keywords: ['交易', '流水', '金融', '市场', '业务'],
    definition: '记录债券、回购、同业等业务的全部交易流水',
    caliber: '统计口径：交易达成日期；包含银行间市场、交易所市场全量交易',
    hidden: false,
  },
  {
    id: '6',
    name: '监管报送指标',
    description: '监管报送所需指标数据汇总',
    department: '合规管理部',
    owner: '赵六',
    path: '监管报送板块>一表通数据核对>监管报送指标',
    authorized: true,
    viewCount: 312,
    likeCount: 45,
    commentCount: 12,
    roles: ['合规管理角色', '监管报送角色'],
    catalogPath: ['监管报送板块', '一表通数据核对'],
    catalogId: 'regulatory-east',
    keywords: ['监管', '报送', '指标', '业务'],
    definition: '汇总 1104、EAST、一表通等监管报送所需指标数据',
    caliber: '统计口径：按监管要求 T+1 报送；数据经校验核对',
    hidden: true, // 默认隐藏，搜索或点击目录时显示
  },
]
